var exports = {
  "D": "Box_0__JSDS8s",
  "w": "Box_1__B8qj_A",
};

module.exports = exports;
